import CommunityBanner from "@/components/pages/Community/CommunityBanner/CommunityBanner";

export default CommunityBanner;
